import React, { useRef } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/oncommit.png";
import estasseguroAvatar from "../../assets/bg/estasseguro-avatar-violet.png";
import ScenarioBar from "../../components/ScenarioBar";
import NextButton from "../../components/NextButton";

function Scenario3Fin({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const videoRef = useRef(null);

	const activeScenario = getScenarioNumByPath(location.pathname);

	return (
        <div className="h-100">
        <div className="container-fluid position-relative h-100 p-0 bgCircleViolet">
            <div className="row h-100 m-0">
            <div className="col-md-12 position-relative h-100 p-0 overflow-hidden">
                <div className="content-overlay d-flex flex-column justify-content-start align-items-center h-75 px-5 position-relative pt-4">
                <img
                    src={oncommit}
                    alt="decorativo"
                    style={{ maxWidth: "187px", top: "18px", left: "20px" }}
                    className="position-absolute"
                />
                <img
                    src={estasseguroAvatar}
                    alt="decorativo"
                    className="m-5"
                    style={{ maxWidth: "360px" }}
                />
                <div className="recuadro recuadro-violet txtTexto1 w-50">
                    <p>
                    Las puertas de la siguiente sala se han abierto. Cada vez estás más cerca de resolver el caso. Avanza y continúa demostrando tu habilidad clínica. Ahora iniciaremos con episodios adversos.
                    </p>
                </div>
                <div className="d-flex align-items-center w-100 justify-content-end">
                    <NextButton
                    navigateTo={ROUTES.TRANSITION_SCENARIOS}
                    activeScenario={4}
                    color="violet"
                    />
                </div>
                </div>
            </div>
            </div>
        </div>

        <ScenarioBar activeScenario={activeScenario} />
        </div>
    );
}

export default injectIntl(Scenario3Fin);
